import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Sample Visualization",
  "description": "Learn how to create and configure sample visualization for API usage monitoring using OpenSearch Dashboard"
};
export let structuredData = {
  "contents": [{
    "heading": "dashboard-name-inference_usage_insights",
    "content": "This guide explains how to create sample visualization for monitoring API usage."
  }, {
    "heading": "purpose",
    "content": "Identify which users (based on api_key_id) are generating the most cost over time. This helps in:"
  }, {
    "heading": "purpose",
    "content": "Billing & quota tracking"
  }, {
    "heading": "data-requirements",
    "content": "Index Pattern: mira-model-usage*Field Used:"
  }, {
    "heading": "data-requirements",
    "content": "api_key_id (user identifier)"
  }, {
    "heading": "data-requirements",
    "content": "cost (total cost per request)"
  }, {
    "heading": "1-open-opensearch-dashboards",
    "content": "Navigate to your domain's dashboard URL."
  }, {
    "heading": "1-open-opensearch-dashboards",
    "content": "Go to Visualize > Create visualization."
  }, {
    "heading": "2-choose-visualization-type",
    "content": "Select Horizontal Bar Chart"
  }, {
    "heading": "3-select-index-pattern",
    "content": "Choose: mira-model-usage*"
  }, {
    "heading": "4-configure-the-y-axis-metric",
    "content": "Aggregation: Sum"
  }, {
    "heading": "4-configure-the-y-axis-metric",
    "content": "Field: cost"
  }, {
    "heading": "4-configure-the-y-axis-metric",
    "content": "Custom Label: Total Cost ($)"
  }, {
    "heading": "5-configure-the-x-axis-bucket",
    "content": "Aggregation: Terms"
  }, {
    "heading": "5-configure-the-x-axis-bucket",
    "content": "Field: api_key_id"
  }, {
    "heading": "5-configure-the-x-axis-bucket",
    "content": "Size: 10 (Top 10 users)"
  }, {
    "heading": "5-configure-the-x-axis-bucket",
    "content": "Order by: Total Cost ($)"
  }, {
    "heading": "5-configure-the-x-axis-bucket",
    "content": "Order: Descending"
  }, {
    "heading": "5-configure-the-x-axis-bucket",
    "content": "Custom Label: User (api_key_id)"
  }, {
    "heading": "6-save-and-add-to-dashboard",
    "content": "Click Save"
  }, {
    "heading": "6-save-and-add-to-dashboard",
    "content": "Name: top_users_by_cost"
  }, {
    "heading": "6-save-and-add-to-dashboard",
    "content": "Title: \"Top Users by Total Cost\""
  }, {
    "heading": "6-save-and-add-to-dashboard",
    "content": "Add to the dashboard: inference_usage_insights"
  }],
  "headings": [{
    "id": "dashboard-name-inference_usage_insights",
    "content": "Dashboard Name: inference_usage_insights"
  }, {
    "id": "visualization-top-users-by-total-cost",
    "content": "Visualization: \"Top Users by Total Cost**"
  }, {
    "id": "purpose",
    "content": "Purpose"
  }, {
    "id": "data-requirements",
    "content": "Data Requirements"
  }, {
    "id": "steps-to-create-the-visualization",
    "content": "Steps to Create the Visualization"
  }, {
    "id": "1-open-opensearch-dashboards",
    "content": "1. Open OpenSearch Dashboards"
  }, {
    "id": "2-choose-visualization-type",
    "content": "2. Choose Visualization Type"
  }, {
    "id": "3-select-index-pattern",
    "content": "3. Select Index Pattern"
  }, {
    "id": "4-configure-the-y-axis-metric",
    "content": "4. Configure the Y-Axis (Metric)"
  }, {
    "id": "5-configure-the-x-axis-bucket",
    "content": "5. Configure the X-Axis (Bucket)"
  }, {
    "id": "6-save-and-add-to-dashboard",
    "content": "6. Save and Add to Dashboard"
  }]
};
export const toc = [{
  depth: 2,
  url: "#dashboard-name-inference_usage_insights",
  title: _jsxs(_Fragment, {
    children: ["Dashboard Name: ", _jsx("code", {
      children: "inference_usage_insights"
    })]
  })
}, {
  depth: 2,
  url: "#visualization-top-users-by-total-cost",
  title: _jsx(_Fragment, {
    children: "Visualization: \"Top Users by Total Cost**"
  })
}, {
  depth: 3,
  url: "#purpose",
  title: _jsx(_Fragment, {
    children: "Purpose"
  })
}, {
  depth: 2,
  url: "#data-requirements",
  title: _jsxs(_Fragment, {
    children: ["Data ", _jsx("strong", {
      children: "Requirements"
    })]
  })
}, {
  depth: 2,
  url: "#steps-to-create-the-visualization",
  title: _jsx(_Fragment, {
    children: "Steps to Create the Visualization"
  })
}, {
  depth: 3,
  url: "#1-open-opensearch-dashboards",
  title: _jsx(_Fragment, {
    children: "1. Open OpenSearch Dashboards"
  })
}, {
  depth: 3,
  url: "#2-choose-visualization-type",
  title: _jsx(_Fragment, {
    children: "2. Choose Visualization Type"
  })
}, {
  depth: 3,
  url: "#3-select-index-pattern",
  title: _jsx(_Fragment, {
    children: "3. Select Index Pattern"
  })
}, {
  depth: 3,
  url: "#4-configure-the-y-axis-metric",
  title: _jsx(_Fragment, {
    children: "4. Configure the Y-Axis (Metric)"
  })
}, {
  depth: 3,
  url: "#5-configure-the-x-axis-bucket",
  title: _jsx(_Fragment, {
    children: "5. Configure the X-Axis (Bucket)"
  })
}, {
  depth: 3,
  url: "#6-save-and-add-to-dashboard",
  title: _jsx(_Fragment, {
    children: "6. Save and Add to Dashboard"
  })
}];
function _createMdxContent(props) {
  const _components = {
    br: "br",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h2, {
      id: "dashboard-name-inference_usage_insights",
      children: ["Dashboard Name: ", _jsx(_components.code, {
        children: "inference_usage_insights"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["This guide explains how to create ", _jsx(_components.strong, {
        children: "sample visualization"
      }), " for monitoring API usage."]
    }), "\n", _jsx(_components.h2, {
      id: "visualization-top-users-by-total-cost",
      children: "Visualization: \"Top Users by Total Cost**"
    }), "\n", _jsx(_components.h3, {
      id: "purpose",
      children: "Purpose"
    }), "\n", _jsxs(_components.p, {
      children: ["Identify which users (based on ", _jsx(_components.code, {
        children: "api_key_id"
      }), ") are generating the most cost over time. This helps in:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Billing & quota tracking"
      }), "\n"]
    }), "\n", _jsxs(_components.h2, {
      id: "data-requirements",
      children: ["Data ", _jsx(_components.strong, {
        children: "Requirements"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Index Pattern:"
      }), " ", _jsx(_components.code, {
        children: "mira-model-usage*"
      }), _jsx(_components.br, {}), "\n", _jsx(_components.strong, {
        children: "Field Used:"
      })]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "api_key_id"
        }), " (user identifier)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "cost"
        }), " (total cost per request)"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "steps-to-create-the-visualization",
      children: "Steps to Create the Visualization"
    }), "\n", _jsx(_components.h3, {
      id: "1-open-opensearch-dashboards",
      children: "1. Open OpenSearch Dashboards"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Navigate to your domain's dashboard URL."
      }), "\n", _jsxs(_components.li, {
        children: ["Go to ", _jsx(_components.strong, {
          children: "Visualize"
        }), " > ", _jsx(_components.strong, {
          children: "Create visualization"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "2-choose-visualization-type",
      children: "2. Choose Visualization Type"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Select ", _jsx(_components.strong, {
          children: "Horizontal Bar Chart"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "3-select-index-pattern",
      children: "3. Select Index Pattern"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Choose: ", _jsx(_components.code, {
          children: "mira-model-usage*"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "4-configure-the-y-axis-metric",
      children: "4. Configure the Y-Axis (Metric)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Aggregation: ", _jsx(_components.code, {
          children: "Sum"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Field: ", _jsx(_components.code, {
          children: "cost"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Custom Label: ", _jsx(_components.code, {
          children: "Total Cost ($)"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "5-configure-the-x-axis-bucket",
      children: "5. Configure the X-Axis (Bucket)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Aggregation: ", _jsx(_components.code, {
          children: "Terms"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Field: ", _jsx(_components.code, {
          children: "api_key_id"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Size: ", _jsx(_components.code, {
          children: "10"
        }), " (Top 10 users)"]
      }), "\n", _jsxs(_components.li, {
        children: ["Order by: ", _jsx(_components.code, {
          children: "Total Cost ($)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Order: ", _jsx(_components.code, {
          children: "Descending"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Custom Label: ", _jsx(_components.code, {
          children: "User (api_key_id)"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "6-save-and-add-to-dashboard",
      children: "6. Save and Add to Dashboard"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Click ", _jsx(_components.strong, {
          children: "Save"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Name: ", _jsx(_components.code, {
          children: "top_users_by_cost"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Title: ", _jsx(_components.strong, {
          children: "\"Top Users by Total Cost\""
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Add to the dashboard: ", _jsx(_components.code, {
          children: "inference_usage_insights"
        })]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
